/* src/components/input-hint/input-hint.component.scss */
:host {
  display: block;
}
.input-hint {
  display: block;
  color: var(--vwui-color-neutral-1);
  font-size: var(--vwui-size-font-sm);
  font-weight: var(--vwui-font-weight-semibold);
  margin-top: 0.3rem;
}
.input-hint--control-invalid {
  color: var(--vwui-color-danger);
}
/*# sourceMappingURL=input-hint.component-ARH73SCE.css.map */
